import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
@Component({
  selector: 'app-advanced-settings-contribution',
  templateUrl: './advanced-settings-contribution.component.html',
  styleUrls: [
    './advanced-settings-contribution.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsContributionComponent implements OnInit {

  constructor(
    private auth: AuthServiceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initQuest({ page: 1 })
    this.initQuestStats()
  }

  quest = {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  }
  initQuest({ page = 1 }) {

    this.auth.getUserQuest({ page: page }).subscribe((res: any) => {
      this.quest = res.body
    })
  }

  questStats: any = {
    likes: 0,
    reports: 0,
    suggests: 0,
  }
  initQuestStats() {
    this.auth.getUserQuestStats().subscribe((res: any) => {
      this.questStats = res.body;
      this.cdr.detectChanges()
      
    })
  }

}
